import React, { useState } from 'react'
import IconButton from '@mui/material/IconButton'
import { Delete } from '@mui/icons-material'
import { Tooltip } from '@mui/material'
import { DialogConfirm } from 'components'

import styles from './styles'

export default (props) => {
  const { index, children, mustRemove, handleRemove } = props

  const classes = styles()
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false)

  const handleCloseConfirm = () => {
    setOpenConfirmDialog(false)
  }

  const handleDelete = () => {
    handleRemove(index)
    handleCloseConfirm()
  }

  const handleOpenDialog = () => {
    setOpenConfirmDialog(true)
  }

  return (
    <div className={classes.root}>
      <div className={classes.content}>{children}</div>
      <div className={classes.actionsRow}>
        <Tooltip title="Remover registro">
          <IconButton onClick={handleOpenDialog}>
            <Delete color={mustRemove ? 'error' : 'default'} />
          </IconButton>
        </Tooltip>
      </div>
      <DialogConfirm
        open={openConfirmDialog}
        onCancel={handleCloseConfirm}
        onConfirm={handleDelete}
        title="Tem certeza de que deseja remover este registro?"
      >
        <div className={classes.confirmationContainer}>
          <div className={classes.confirmationContent}>{children}</div>
          <p>Essa ação é irreversível e não poderá ser desfeita.</p>
        </div>
      </DialogConfirm>
    </div>
  )
}
